document.addEventListener('DOMContentLoaded', function () {
    const languageLinks = document.querySelectorAll('#LanguageList a');
    const languageForm = document.querySelector('localization-form form');
    const languageInput = languageForm.querySelector('input[name="language_code"]');

    languageLinks.forEach((link) => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const selectedLang = this.dataset.value;
            languageInput.value = selectedLang;
            languageForm.submit();
        });
    });
});